<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     伙伴等级选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-select v-model="level" :placeholder="placeholder" filterable clearable @change="selectChange" :style="{ width: width ? width + 'px' : '100%' }">
    <el-option
      v-for="(item, index) in partnerLevelArr"
      :key="index"
      :label="item.title"
      :value="item.value">
      {{ item.title }}
    </el-option>
  </el-select>

</template>

<script>

export default {
  name: "PartnerLevelSelector",

  props: {
    value: {
      type: [Number, String],
      default: 0
    },

    placeholder: {
      type: String,
      default: '客户等级'
    },

    width: {
			type: String,
			default: ''
		}
  },

  data() {
    return {

    }
  },

  computed: {
    level: {
      get() {
        return this.value ? this.value : null
      },
      set(val) {
        this.$emit('input', val ? val : null)
      }
    },

    partnerLevelArr(state) {
      return this.$store.state.userStore.partnerLevelArr
    }
  },

  created() {
  },

  methods: {
    selectChange(val) {
      const list = this.partnerLevelArr.map(v => v.value)
      const index = list.indexOf(val)
      const item = this.partnerLevelArr[index]
      this.$emit('change', item)
    }
  }
}
</script>
